
const $searchForm = $('.js-jobs-search-form');

var currentPageIndex = null;
var isLoading = false;
var isLastPage = false;

$(document).ready(function () {
    
    // Group Filter: Reset and Submit dropdown menu buttons management.
    $(document).on('click', '.js-group-filter-submit-btn', function (e) {
        refreshGroupFilterText();
        $searchForm.submit();
    });

    $(document).on('click', '.js-group-filter-reset-btn', function (e) {
        const $dropdownMenu = $(this).closest('.dropdown-menu');
        resetDropdownMenu($dropdownMenu);
        refreshGroupFilterText();
        $searchForm.submit();
    });

    // Region Filter: Reset and Submit dropdown menu buttons management.
    $(document).on('click', '.js-region-filter-submit-btn', function (e) {
        updateRegionHiddenInput();
        refreshRegionFilterText();
        $searchForm.submit();
    });
   
    $(document).on('click', '.js-region-filter-reset-btn', function (e) {
        const $dropdownMenu = $(this).closest('.dropdown-menu');
        resetDropdownMenu($dropdownMenu);
        updateRegionHiddenInput();
        refreshRegionFilterText();
        $searchForm.submit();
    });

    var refreshGroupFilterText = function () {
        refreshFilterButtonText($searchForm.find(".js-group-filter"), "Domaines");
    };

    var refreshRegionFilterText = function () {
        refreshFilterButtonText($searchForm.find(".js-region-filter"), "Localisation");
    };

    var resetDropdownMenu = function ($dropdownMenu) {
        $dropdownMenu.find(':checkbox').prop('checked', false);
    };

    var refreshFilterButtonText = function ($filterElt, defautText) {
        const $btnFilter = $filterElt.find(".btn-filter");
        let $checkedItems = $filterElt.find("input:checked");
        if ($checkedItems.length > 0) {
            let selectedFilterText = "";
            $checkedItems.each(function (itemIndex, elt) {
                const checkedItemLabel = $filterElt.find('label[for="' + $(this).attr('id') + '"]').text();
                if (itemIndex === 0) {
                    selectedFilterText = checkedItemLabel;
                }
                else if (itemIndex < 1) {
                    selectedFilterText += ", " + checkedItemLabel;
                }
                else {
                    selectedFilterText += ", +" + ($checkedItems.length - 1).toString();
                    return false;
                }
            });
            $btnFilter.text(selectedFilterText);
            $btnFilter.toggleClass("active", true);
        }
        else {
            $btnFilter.text(defautText);
            $btnFilter.toggleClass("active", false);
        }
    };

    // Region filter values are maintained into an hidden input.
    var updateRegionHiddenInput = function () {
        const $hiddenInput = $searchForm.find(".js-hidden-input-regions");
        const $checkedItems = $searchForm.find(".js-region-filter input:checked");
        let hiddenVal = "";
        if ($checkedItems.length > 0) {
            $checkedItems.each(function (itemIndex, elt) {
                const regionCode = $(this).data("regionCode");
                if (itemIndex === 0) {
                    hiddenVal = regionCode;
                }
                else {
                    hiddenVal += "," + regionCode;
                }
            });
        }
        $hiddenInput.val(hiddenVal);
    };

    //Prevents the bootstrap dropdown menu close when clicked inside.
    $('.js-dropdown-dont-close').on({
        "click.bs.dropdown": function (e) {
            if (!$(e.target).is(".js-dropdown-footer > button")
                && !$(e.target).is(".js-dropdown-close-btn > span"))
                e.stopPropagation();
        }
    });

    //Prevents page scrolling when full-screen dropdown is open.
    $('.js-dropdown-dont-close').parent().on({
        "shown.bs.dropdown": function (e) {
            $("body").addClass("mobile-fixed-no-overflow");
        },
        "hidden.bs.dropdown": function (e) {
            $("body").removeClass("mobile-fixed-no-overflow");
        }
    });    

  

    $searchForm.on('submit', function(e) {
        e.preventDefault();
        currentPageIndex = null;
      
        getJobsResultsAsync(currentPageIndex);
    });

      // infinite scroll.
    $(window).on('scroll', function() {
        let height = $(document).height();
        let scrollTop = $(document).scrollTop();
        if ((scrollTop / height) * 100 > 70 && !isLoading && !isLastPage) {
            isLoading = true;
            currentPageIndex++;
            getJobsResultsAsync(currentPageIndex);
        }
    });

    refreshGroupFilterText();
    refreshRegionFilterText();
    getJobsResultsAsync(currentPageIndex);
});



function getJobsResultsAsync(currentPageIndex) {
    const $offersList = $('.js-offers-list');
    
    var filtersData = $searchForm.serialize();
    
    var pageIndex = null;
    if (currentPageIndex !== null) {
        pageIndex = currentPageIndex + 1;
    }
    else { // clear results if we load the firt page of result.
        $offersList.empty();
    }

    let data = filtersData + '&pageIndex=' + pageIndex;
    
    $.ajax({
        url: "/Search/GetJobsResults",
        type: 'GET',
        data: data,
        dataType: 'json',
        success: function (data) {
            $offersList.append(data.html);
            $('.js-jobs-count').text(data.totalCount);
            $('.js-jobs-count-label').text(data.totalCount > 1 ? "offres de job" : "offre de job");
            isLoading = false;
            isLastPage = data.isLastPage;
        },
        error: function (data) {
            console.log("Unexpected error occured while loading job offers.");
            isLoading = false;
        }
    });
    //return pageIndex;

    urlPushState();
}

function buildUrl(query, filteredGroups, filteredRegions, jobAuthor) {
    let urlTemplate = window.location.protocol + "//" + window.location.host
        + '/Search?';
    if (query != "") {
        query = encodeURIComponent(query);
        urlTemplate += "queryText={query}&";
    }
    if (filteredGroups != "") {
        urlTemplate += "{groups}&";
    }
    if (filteredRegions != "") {
        urlTemplate += "regions={regions}&";
    }
    if (jobAuthor != "") {
        urlTemplate += "jobAuthor={jobAuthor}&";
    }
        // + "?queryText={query}&{filters}";
        // + "?queryText={query}&location={where}&{filters}";
    let newUrl = urlTemplate.replace('{query}', query)
        .replace('{groups}', filteredGroups)
        .replace('{regions}', filteredRegions)
        .replace('{jobAuthor}', jobAuthor);

    return newUrl;
};

function urlPushState() {
    if (history.pushState) {
        const queryText = $searchForm.find('.js-jobs-search-query-input').val();
        const regionFilters = $searchForm.find('.js-hidden-input-regions').val();
        const groupFilters = $searchForm.find('.js-group-filter input').serialize();
        const jobAuthor = $searchForm.find('.js-hidden-input-job-author').val();


        const newUrl = buildUrl(queryText, groupFilters, regionFilters, jobAuthor);
        window.history.replaceState({ path: newUrl }, '', newUrl);
    }
};
